import {
	provideKeycloak,
	createInterceptorCondition,
	IncludeBearerTokenCondition,
	INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
	withAutoRefreshToken,
	AutoRefreshTokenService,
	UserActivityService
} from 'keycloak-angular';

/**
 * Keycloak-URL für alle Luzula-Apps.
 * Zentral in der Lib definiert.
 */
const KEYCLOAK_URL = 'https://id.waldkonzepte.de';

/**
 * Standard Bearer-Token-Interceptor-Condition für lokale Entwicklung.
 */
const localhostCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
	urlPattern: /^(http:\/\/localhost:8181)(\/.*)?$/i
});

/**
 * Konfiguriert Keycloak-Authentifizierung für eine Luzula-App.
 *
 * Kapselung der keycloak-angular Konfiguration mit festem Server-URL
 * und Standard-Settings (Auto-Refresh, Bearer-Token-Interceptor).
 *
 * @param realm - Keycloak-Realm (z.B. 'waldmv', 'luzula')
 * @param clientId - Keycloak-Client-ID (z.B. 'bpweb', 'forsteinrichtung')
 *
 * @example
 * ```typescript
 * // In app.module.ts providers:
 * provideLuzulaAuth('waldmv', 'bpweb'),
 * provideHttpClient(withInterceptors([includeBearerTokenInterceptor, errorCaptureInterceptor])),
 * ```
 */
export function provideLuzulaAuth(realm: string, clientId: string) {
	return provideKeycloak({
		config: {
			realm,
			url: KEYCLOAK_URL,
			clientId
		},
		features: [
			withAutoRefreshToken({
				onInactivityTimeout: 'logout',
				sessionTimeout: 60000
			})
		],
		providers: [
			AutoRefreshTokenService,
			UserActivityService,
			{
				provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
				useValue: [localhostCondition]
			}
		]
	});
}
